module.exports = __webpack_public_path__ + "static/media/painkillers.b207522d.jpeg";